// How entries read in lists and tooltips, as on the phone (Timeline.kt and JournalEntry.kt).

import type { EntryDTO, PumpDTO } from "./dto.js";
import { ACTIVITY_TYPES, FOOD_EMOJI, INTENSITIES, MEALS, NOTE_EMOJI, roundHalfUp, RunFormat } from "./journal.js";

export function entryEmoji(entry: EntryDTO): string {
  switch (entry.kind) {
    case "food":
      return FOOD_EMOJI;
    case "activity":
      return ACTIVITY_TYPES[entry.type].emoji;
    case "note":
      return NOTE_EMOJI;
  }
}

/** The entry's text without its emoji: "Lunch: pasta", "Run · 8.2 km · 45 min · 5:23/km", "new sensor". */
export function headline(entry: EntryDTO): string {
  switch (entry.kind) {
    case "food":
      return (entry.meal ? `${MEALS[entry.meal]}: ` : "") + entry.text;
    case "activity": {
      let s = ACTIVITY_TYPES[entry.type].label;
      const run = entry.run;
      if (run) {
        s += ` · ${RunFormat.distance(run.distanceM)} · ${RunFormat.duration(run.durationS)}`;
        if (run.paceSecPerKm !== null) s += ` · ${RunFormat.pace(run.paceSecPerKm)}`;
      } else {
        s += ` · ${entry.minutes} min`;
        if (entry.intensity) s += ` · ${INTENSITIES[entry.intensity].toLowerCase()}`;
      }
      if (entry.text && entry.text.trim() !== "") s += ` — ${entry.text}`;
      return s;
    }
    case "note":
      return entry.text;
  }
}

/** "Garmin" for imported runs; mocked runs say so. */
export function sourceLabel(source: string): string {
  if (source === "garmin") return "Garmin";
  if (source === "mock") return "Garmin (mock)";
  return source;
}

/** "60 g carbs · 6.0 U" */
export function pumpSummary(pump: PumpDTO): string {
  const parts: string[] = [];
  if (pump.carbs) parts.push(`${Math.round(pump.carbs)} g carbs`);
  if (pump.insulin) parts.push(`${roundHalfUp(pump.insulin, 1).toFixed(1)} U`);
  return parts.join(" · ");
}
